<template>
  <div class="rigester-box show-flex-box-c show-flex-center" @click.self="colseRegisterWin()" v-show="isShowRegister">
    <div class="rigester-total show-flex-box-r show-flex-center">

      <div class="rigester-all show-flex-box-c" v-if="!isShowUserAgreement && !isShowPrivacyPolicy">
        <!-- X图标 -->
        <em @click.self="colseRegisterWin()"></em>
        <dl class="rigester-content show-flex-box-c">
          <dt class="select-rigester-way show-flex-box-r">
            <ul class="select-rigester-way-list show-flex-box-r">
              <li class="select-rigester-way-item show-flex-box-c" :class="{'selected-rigester-active': registerType == item.type}" v-for="(item, index) in rigesterOptions" :key="index" @click="selectedRegisterWay(item)">
                <span>{{item.title}}</span>
                <em></em>
              </li>
            </ul>
            <span @click="backLogin()">返回登录</span>
          </dt>
          <dd class="account-box show-flex-box-c">
            <div class="account-content-info show-flex-box-c">

              <ul class="account-content-password-input  message-rigester-input show-flex-box-c" v-if="registerType == 'phone'">
                <li class="show-flex-box-r">
                  <em></em>
                  <span class="show-flex-box-r">
                    <input type="number" placeholder="请输入手机号" v-model="phoneRegisterFrom.phone">
                  </span>
                </li>
                <li class="show-flex-box-r">
                  <em></em>
                  <span class="show-flex-box-r"> 
                    <input type="number" placeholder="请输入验证码" v-model="phoneRegisterFrom.verifiyCode">
                  </span>
                  <h3 class="show-flex-box-r" v-if="!countDown">
                    <em></em>
                    <strong @click="verifyCodeCountDown()">获取验证码</strong>
                  </h3>
                   <h4 class="show-flex-box-r" v-else>
                    <em></em>
                    <strong>{{remainCount}}s</strong>
                  </h4>
                </li>
                <li class="show-flex-box-r">
                  <em></em>
                  <span class="show-flex-box-r">
                    <input type="password" placeholder="请设置密码" v-model="phoneRegisterFrom.password">
                  </span>
                </li>
                <li class="show-flex-box-r">
                  <em></em>
                  <span class="show-flex-box-r">
                    <input type="password" placeholder="请确认密码" v-model="phoneRegisterFrom.secondPassword">
                  </span>
                </li>

              </ul>

              <ul class="account-content-password-input  message-rigester-input  email-rigester-input   show-flex-box-c" v-if="registerType == 'email'">
                <li class="show-flex-box-r">
                  <em></em>
                  <span class="show-flex-box-r">
                    <input type="text" placeholder="请输入邮箱" v-model="emailRegisterFrom.email">
                  </span>
                </li>
                <li class="show-flex-box-r">
                  <em></em>
                  <span class="show-flex-box-r">
                    <input type="text" placeholder="请输入验证码" v-model="emailRegisterFrom.verifiyCode">
                  </span>
                   <h3 class="show-flex-box-r" v-if="!emailCountDown">
                    <em></em>
                    <strong @click="verifyCodeCountDown()">获取验证码</strong>
                  </h3>
                  <h4 class="show-flex-box-r" v-else>
                    <em></em>
                    <strong>{{remainEmailCount}}s</strong>
                  </h4>
                </li>
                <li class="show-flex-box-r">
                  <em></em>
                  <span class="show-flex-box-r">
                    <input type="password" placeholder="请设置密码" v-model="emailRegisterFrom.password">
                  </span>
                </li>
                <li class="show-flex-box-r">
                  <em></em>
                  <span class="show-flex-box-r">
                    <input type="password" placeholder="请确认密码" v-model="emailRegisterFrom.secondPassword">
                  </span>
                </li>
              </ul>

            </div>
            <h3 class="show-flex-box-r">
              <span>登录注册即同意</span>
              <em @click="openUserAgreementPop()">“用户协议”</em>
              <span>和</span>
              <em @click="openPrivacyPolicyPop()">“隐私协议”</em>
            </h3>
            <span class="show-flex-box-r">
              <span @click="clickToRegister()">完成</span>
             </span>
          </dd>
        </dl>
      </div>

      <div class="user-agreement show-flex-box-c" v-if="isShowUserAgreement">
        <h3 class="show-flex-box-r show-flex-center">
          <em @click="closeUserAgreementPop()"></em>
          <span>用户协议</span>
        </h3>
        
        <div class="show-flex-box-c">
          <div>
            <div class="box-scrollbar-hidden" v-html="userAgreement"></div>
          </div>
          
        </div>
      </div> 
      <div class="user-agreement show-flex-box-c" v-if="isShowPrivacyPolicy">
        <h3 class="show-flex-box-r show-flex-center">
          <em @click="closePrivacyPolicyPop()"></em>
          <span>隐私政策</span>
        </h3>
        
        <div class="show-flex-box-c">
          <div>
            <div class="box-scrollbar-hidden" v-html="privacyPolicy"></div>
          </div>
            
        </div>
      </div>


    </div>
  </div>
</template>

<script>
  import wx from 'weixin-js-sdk'
  import regex from "@/filter/regex";
  import { CountDown } from "@/../static/js/CountDown";
  // import {FindpasswordUser} from "@/model/login_user.js";

  export default {
    name: "register",
    data() {
      return {
        rigesterOptions: [{
            type: 'phone',
            title: '手机注册'
          }, 
          {
            type: 'email',
            title: '邮箱注册'
          }, 
        ],
        isShowRegister: false,
        registerType:'phone',
        // passwordQuestion : false,
        remainCount:60,
        countDown: false,
        remainEmailCount:60,
        emailCountDown: false,

        phoneRegisterFrom:{
          phone:'',  
          verifiyCode:'',
          password:'',
          secondPassword:''
        },
        emailRegisterFrom:{
          email:'',  
          verifiyCode:'',
          password:'',
          secondPassword:''
        },
        userAgreement: "",
        isShowUserAgreement: false,
        privacyPolicy:"",
        isShowPrivacyPolicy: false,
    };
    },
    components: {},
    mounted() {
      // this.initCountDown();
      this.getUserAgreement();
      this.getUserPrivacyPolicy();
    },
    methods: {
      getUserAgreement: function() {
        var params = {
          code: "tv_platform_agreement"
        };

        this.$client
          .getDocumentDetail(params)
          .then(res => {
            this.userAgreement = res.data.content;
          })
          .catch(err => {
            this.$message({
              showClose: true,
              message: err.data.message,
              type: "error"
            });
          });
      },
      getUserPrivacyPolicy: function() {
        var params = {
          code: "tv_privacy_agreement"
        };

        this.$client
          .getDocumentDetail(params)
          .then(res => {
            this.privacyPolicy = res.data.content;
          })
          .catch(err => {
            this.$message({
              showClose: true,
              message: err.data.message,
              type: "error"
            });
          });
    },
      colseRegisterWin: function() {
        this.isShowRegister = !this.isShowRegister;
      },
      selectedRegisterWay: function(item) {
        this.registerType = item.type
      },
      clickToRegister: function() {
        if(this.checkCanVerify() && this.validRegisterParams()){
          var params = null;
          if(this.registerType == 'phone'){
            params = {
              account: this.phoneRegisterFrom.phone,
              account_type: this.registerType,
              verify_code: this.phoneRegisterFrom.verifiyCode,
              password: this.phoneRegisterFrom.password
            }
          }else{
            params = {
              account: this.emailRegisterFrom.email,
              account_type: this.registerType,
              verify_code: this.emailRegisterFrom.verifiyCode,
              password: this.emailRegisterFrom.password
            }
          };
          this.$client
            .userRegister(params)
            .then(res => {
              if (res.code == 200) {
                var userToken = res.data.token;
                var userInfo = res.data.user;
                this.registerSucceed(userToken);
                this.resetForm();
                this.isShowRegister = false;
              }
            })
            .catch(err => {
              this.$message({
                showClose: true,
                message: err && err.data ? err.data.message : '注册失败，请重试',
                type: "error"
              });
            });
        }
      },
      registerSucceed: function(token) {
        let saveTokenObj = {
          token: token
        };
        this.$store.commit("SET_TOKEN", saveTokenObj);
        this.$store.commit("LOGIN", true); //登录成功后改变登录状态
        // this.$parent.$refs.login.toCloseLoginPop();
        // this.isShowRegister = false;
        this.backLogin();
      },
      validRegisterParams: function() {
        var status = true;
        if(this.registerType == 'phone'){
          if(regex.isEmpty(this.phoneRegisterFrom.verifiyCode)){
            this.$message({
              showClose: true,
              message: "请输入您收到的验证码",
              type: "error"
            });
            return false;
          };
          if(regex.isEmpty(this.phoneRegisterFrom.password)){
            this.$message({
              showClose: true,
              message: "请输入您的密码",
              type: "error"
            });
            return false;
          };
          if(this.phoneRegisterFrom.password != this.phoneRegisterFrom.secondPassword){
             this.$message({
              showClose: true,
              message: "您两次输入的密码不一致",
              type: "error"
            });
            return false;
          }
          return status;

           
        }else{

          if(regex.isEmpty(this.emailRegisterFrom.verifiyCode)){
            this.$message({
              showClose: true,
              message: "请输入您收到的验证码",
              type: "error"
            });
            return false;
          };
          if(regex.isEmpty(this.emailRegisterFrom.password)){
            this.$message({
              showClose: true,
              message: "请输入您的密码",
              type: "error"
            });
            return false;
          };
          if(this.emailRegisterFrom.password != this.emailRegisterFrom.secondPassword){
             this.$message({
              showClose: true,
              message: "您两次输入的密码不一致",
              type: "error"
            });
            return false;
          };
           return status;
        };

      },

      initCountDown: function() {
        var _this = this;
        this.counter = new CountDown(60, function(cnt) {
          if (0 === cnt) {
            _this.countDown = false,
            _this.counter && _this.counter.cancel();
          } else {
            _this.remainCount = cnt;
          }
        });
      },
      initEmailCountDown: function() {
        var _this = this;
        this.counter = new CountDown(60, function(cnt) {
          if (0 === cnt) {
            _this.emailCountDown = false,
            _this.counter && _this.counter.cancel();
          } else {
            _this.remainEmailCount = cnt;
          }
        });
      },
      
      verifyCodeCountDown: function() {
        if(this.checkCanVerify()) {
          if(this.registerType == 'phone'){
            if(!this.countDown){
              this.initCountDown();
            }
          }else{
            if(!this.emailCountDown){
              this.initEmailCountDown();
            }
          }
          this.sendMessage();
        }
      },
      checkCanVerify: function() {
        var status = true;

        if (this.registerType == 'phone') {
          if (regex.isEmpty(this.phoneRegisterFrom.phone)) {
            this.$message({
              showClose: true,
              message: "请输入您的手机号",
              type: "error"
            });
            return false;
          }

          if (!regex.isPhoneNumber(this.phoneRegisterFrom.phone)) {
            this.$message({
              showClose: true,
              message: "您输入的手机号格式不正确",
              type: "error"
            });
            return false;
          } 
        } else if(this.registerType == 'email'){
          if (regex.isEmpty(this.emailRegisterFrom.email)) {
            this.$message({
              showClose: true,
              message: "请输入您的邮箱",
              type: "error"
            });
            return false;
          }

          if (!regex.isEmail(this.emailRegisterFrom.email)) {
            this.$message({
              showClose: true,
              message: "您输入的邮箱格式不正确",
              type: "error"
            });
            return false;
          } 
        }

        return status;
      },
      sendMessage: function() {
        var params = {
          account: this.registerType == 'phone'? this.phoneRegisterFrom.phone : this.emailRegisterFrom.email,
          way: this.registerType,
          type: "register"
        };

         this.$client.sendVerifyCode(params)
        .then(res => {
          if(this.registerType == 'phone'){
            this.countDown = true;
          }else{
            this.emailCountDown = true;
          }
          
          this.counter.start();
        }).catch(err => {
          this.counter && this.counter.cancel();
          this.emailCountDown = false;
          this.countDown = false;

          if (err.data && err.data.message) {
            this.$message({
              showClose: true,
              message: err.data.message,
              type: "error"
            });
          }
        });
      },
      resetForm: function() {
        this.phoneRegisterFrom.phone = "";
        this.phoneRegisterFrom.verifiyCode = "";
        this.phoneRegisterFrom.password = "";
        this.phoneRegisterFrom.secondPassword = "";
        this.emailRegisterFrom.email = "";
        this.emailRegisterFrom.verifiyCode = "";
        this.emailRegisterFrom.password = "";
        this.emailRegisterFrom.secondPassword = "";
      },
      backLogin: function() {
        this.$parent.$refs.login.colseLoginWin();
        this.isShowRegister = false;
      },

      closeUserAgreementPop: function() {
        this.isShowUserAgreement = false;
      },
      openUserAgreementPop: function() {
        this.isShowUserAgreement = true;
      },
      closePrivacyPolicyPop: function() {
        this.isShowPrivacyPolicy = false
      },
      openPrivacyPolicyPop: function() {
        this.isShowPrivacyPolicy = true;
      },

        
    },
    watch:{
      isShowRegister: function() {
        this.resetForm();
        this.registerType == 'phone';
      }
    }
  };

</script>
<style lang="less" scoped>
  .rigester-box{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background: rgba(0, 0, 0, 0.4);
    .rigester-total{
      width:560px;
      padding: 30px 0px 60px 0px; 
      background:#FFFFFF;
      border-radius:8px;
      position: absolute;
      .rigester-all{
        width: 506px;
        height: 100%;
        align-items: flex-end;
        padding-left: 22px;
        >em{
          display: block;
          width: 22px;
          height: 22px;
          background: url("../../assets/login/close_arrow_icon.png") no-repeat center center;
          background-size: 22px 22px;
          margin-bottom: 18px;
          flex-shrink: 0;
          cursor: pointer;
        }
        >dl{
          width: 100%;
          >dt{
            padding-right: 23px;
            align-items: flex-end;
            margin-bottom: 30px;
            >ul{
              width: 100%;
              align-items: center;
              >li{
                align-items: center;
                margin-right: 25px;
                cursor: pointer;
                >span{
                  font-size:24px;
                  font-family:PingFangSC-Regular,PingFang SC;
                  font-weight:400;
                  color:#999999;
                  line-height:33px;
                  white-space: nowrap;
                  flex-shrink: 0;
                  margin-bottom: 5px;
                }
              }
              .selected-rigester-active{
                >span{
                  color:#333333;
                }
                >em{
                  width:35px;
                  height:5px;
                  background:#CB1309;
                  border-radius:3px;
                }
              }
            }
            >span{
              font-size:15px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              color:#333333;
              line-height:21px;
              white-space: nowrap;
              flex-shrink: 0;
              margin-bottom: 10px;
              cursor: pointer;
            }
          }
          .account-box{
            width: 100%;
            .account-content-info{
              padding-right: 23px;
              .account-content-password-input{
                width: 100%;
                >li{
                  padding: 0px 15px;
                  height:60px;
                  background:#FAFAFA;
                  box-shadow:3px 3px 3px 0px #F4F4F9;
                  border-radius:4px;
                  border:1px solid #EEEEEF;
                  margin-bottom: 20px;
                  align-items: center;
                  cursor: pointer;
                  >em{
                    width: 20px;
                    height: 20px;
                    display: block;
                    background: url(../../assets/login/account_icon.png) no-repeat center center;
                    background-size: 100% 100%;
                    flex-shrink: 0;
                  }
                  >span{
                    flex-grow: 1;
                    margin-left: 20px;
                    align-items: center;
                    >input{
                      width: 100%;
                      height: 100%;
                      font-size:16px;
                      font-family:PingFangSC-Medium,PingFang SC;
                      font-weight:500;
                      color:#333333;
                      line-height:22px;
                    }
                  }
                  >strong{
                    font-size:12px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:#CB1309;
                    line-height:17px;
                    cursor: pointer;
                  }
                }
                >li:hover{
                  padding: 0px 15px;
                  height:60px;
                  background:rgba(203,19,9,0.04);
                  box-shadow:3px 3px 3px 0px rgba(203,19,9,0.1);
                  border-radius:4px;
                  border:1px solid rgba(203,19,9,1);
                }
                >li:nth-child(3) {
                  >em{
                    flex-shrink: 0;
                    width: 20px;
                    height: 20px;
                    display: block;
                    background: url(../../assets/login/password_icon.png) no-repeat center center;
                    background-size: 100% 100%;
                    flex-shrink: 0;
                  }
                }
                
                >li:nth-child(4) {
                  >em{
                    flex-shrink: 0;
                    width: 20px;
                    height: 20px;
                    display: block;
                    background: url(../../assets/login/password_icon.png) no-repeat center center;
                    background-size: 100% 100%;
                    flex-shrink: 0;
                  }
                }
              }
              .message-rigester-input{
                >li>em{
                  width: 20px;
                  height: 20px;
                  display: block;
                  background: url(../../assets/login/tel_icon.png) no-repeat center center;
                  background-size: 100% 100%;
                  flex-shrink: 0;
                }
                >li:nth-child(2)>em{
                  width: 20px;
                  height: 20px;
                  display: block;
                  background: url(../../assets/login/verify_icon.png) no-repeat center center;
                  background-size: 100% 100%;
                  flex-shrink: 0;
                }
                >li:nth-child(2)>h3{
                  width: 80px;
                  padding-left: 15px;
                  height: 20px;
                  border-left: 1px #CB1309 solid;
                  flex-shrink: 0;
                  >em{
                    width: 15px;
                    height: 15px;
                    display: block;
                    background: url(../../assets/login/message_icon.png) no-repeat center center;
                    background-size: 100% 100%;
                    flex-shrink: 0;
                    margin-top: 3px;
                  }
                  >strong{
                    font-size:12px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:#CB1309;
                    line-height:20px;
                    margin-left: 5px;
                    cursor: pointer;
                    flex-shrink: 0;
                    white-space: nowrap;
                  }
                }
                 >li:nth-child(2)>h4{
                   width: 60px;
                  padding-left: 35px;
                  height: 20px;
                  border-left: 1px #CB1309 solid;
                  flex-shrink: 0;
                  cursor: default;
                  >em{
                    width: 15px;
                    height: 15px;
                    display: block;
                    background: url(../../assets/login/gray_message_icon.png) no-repeat center center;
                    background-size: 100% 100%;
                    flex-shrink: 0;
                    margin-top: 3px;
                  }
                  >strong{
                    font-size:12px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:#CCCCCC;
                    line-height:20px;
                    margin-left: 5px;
                  }
                 }
              }

              .email-rigester-input{
                >li>em{
                  width: 20px;
                  height: 20px;
                  display: block;
                  background: url(../../assets/login/email_icon.png) no-repeat center center;
                  background-size: 100% 100%;
                  flex-shrink: 0;
                }
              }
            }
            >h3{
              align-items: center;
              font-size:13px;
              font-family:PingFangSC-Regular,PingFang SC;
              font-weight:400;
              line-height:18px;
              margin-bottom: 30px;
              >span{
                color:#999999;
              }
              >em{
                color: #666666;
                cursor: pointer;
              }
              >em:hover{
                text-decoration: underline;
              }
            }
            >span{
              padding-right: 23px;
              >span{
                cursor: pointer;
                width: 100%;
                height:60px;
                background:#CB1309;
                box-shadow:0px 2px 4px 0px #CB1309;
                border-radius:4px;
                line-height: 60px;
                text-align: center;
                font-size:16px;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                color:rgba(255,255,255,1);
              }
              
            }
          }
        }
      }
      .user-agreement{
        width: 506px;
        // height: 553px;
        // overflow: auto;
        overflow: hidden;
        >h3{
          width: 100%;
          position: relative;
          margin-bottom: 30px;
          >em{
            position: absolute;
            display: block;
            width: 33px;
            height: 33px;
            background: url("../../assets/login/left_arrow_icon.png") center center no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
            left: 0;
            top: 0px;

          }
          >span{
            font-size:24px;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            color:rgba(51,51,51,1);
          }
        }
        
        >div{
          width: 526px;
          height: 425px;
          overflow-y: scroll;
          overflow-x: hidden;
          >div{
            width: 506px;
            font-size: 16px;
            font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
            font-weight: 400;
            color: rgba(48, 41, 41, 1);
            line-height: 24px;
            // overflow-y: hidden;
            // .box-scrollbar-hidden{
            //   width: 526px;
            // }
          }
        
        }

      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/views/login/register.vue